export default __webpack_public_path__ + "static/button-decoration-dont-dark-b148b9b4aed5420b11c53771372a6639.png";